import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-xl shadow-sm border border-warm-200 overflow-hidden ${className}`} {...props} data-id="element-132">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`px-6 py-5 border-b border-warm-100 ${className}`} data-id="element-133">
      {children}
    </div>;
}
export function CardBody({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 ${className}`} data-id="element-134">{children}</div>;
}
export function CardFooter({
  children,
  className = ''
}: CardProps) {
  return <div className={`px-6 py-4 bg-warm-50 border-t border-warm-100 ${className}`} data-id="element-135">
      {children}
    </div>;
}